import Udesk from 'Udesk';
import React, { useState, useEffect, useCallback, useRef, useImperativeHandle } from 'react';
import useResizeObserver from 'use-resize-observer';
import { useInputValue } from './hooks';
import { Icon } from 'udesk-ui';
import ChatRecord from 'Component/common/chat-record';
import './style.scss';

const useAudio = () => {
    const [instance] = useState(new Audio());
    const [isPlaying, setIsPlaying] = useState<number>(-1);
    const playingIndexRef = useRef<number>(-1);

    useEffect(() => {
        const cb = () => {
            setIsPlaying(-1);
            playingIndexRef.current = -1;
        };
        instance.addEventListener('ended', cb);
        return () => {
            instance.removeEventListener('ended', cb);
        };
    }, [instance]);

    return { instance, isPlaying, setIsPlaying, playingIndexRef };
};

let timer2: NodeJS.Timeout | null = null;

const ExportComponent = React.forwardRef((props: any, forwardRef) => {
    const {
        detail,
        inspectDataSource,
        /**
         * @virtual 是否启用虚拟化
         */
        virtual = true,
        /**
         * @autoStepToNext 播放中 高亮是否自动跳转到下一句
         */
        autoStepToNext,
        currentHighLightPointOrSmartKey,
        closeHighLight,
        changeToHighlightItemsCallDetail,
        loading = false,
        isTest, //规则测试
        showCheckbox, //显示左侧勾选
        onMessageItemCheckboxClick,
        //调试
        isDebug,
        indexPointTag,
        hitHighlightList = [],
    } = props;

    const { instance: playingRudio, playingIndexRef, isPlaying, setIsPlaying } = useAudio();

    const [loadingDelay, setLoadingDelay] = useState(false);
    useEffect(() => {
        setLoadingDelay(loading);
    }, [loading]);
    /**
     * @type 关键字高亮功能-选择高亮角色
     */
    const [type] = useState(Udesk.enums.applyRoles.all.id);
    /**
     * @keywords 关键字高亮功能-高亮关键字
     */
    const [keywords, setKeywords] = useInputValue(props.keywords);

    const [timeRangeList, setTimeRangeList] = useState<[number, number][]>([]);

    /**
     * @height 对话记录窗口高度
     */
    const [height, setHeight] = useState(1);

    const chatRecordRef = useRef<any>(null);
    useImperativeHandle(forwardRef, () => {
        return chatRecordRef.current;
    });
    /**
     *
     * @sentenceIndex 当前播放的句子索引
     */
    const [sentenceIndex, setSentenceIndex] = useState<number | null>(null);

    /**
     * pointsHighlight 质检点的高亮信息
     */
    const [, setPointsHighlight] = useState<any[]>([]);

    /**
     * @dialogSentenceList 格式化对话数据
     */
    const [dialogSentenceList, setDialogSentenceList] = useState<any[]>([]);

    const playRudio = useCallback(
        (url, index) => {
            console.log('playRudio', url, index);
            playingRudio.pause();
            if (playingIndexRef.current === -1 || playingIndexRef.current !== index) {
                playingRudio.src = url;
                playingRudio.play();
                playingIndexRef.current = index;
                setIsPlaying(index);
            } else {
                playingIndexRef.current = -1;
                setIsPlaying(-1);
            }
        },
        [playingIndexRef, playingRudio, setIsPlaying]
    );

    /**初始化对话记录列表高度 */
    useEffect(() => {
        // resizeHandler();
        let newTimeRange =
            detail?.dialogRecords?.dialogSentenceList?.map((item) => {
                return [item.fromSec, item.endSec];
            }) ?? [];
        setTimeRangeList(newTimeRange);
    }, [detail?.dialogRecords?.dialogSentenceList]);

    const sendCurrentTimeRange = useCallback(
        (item) => {
            props.onTimeRangeChanged?.(item);
        },
        [props.onTimeRangeChanged]
    );
    const closeHighLightAndClearKeyWords = useCallback(() => {
        setKeywords('');
        closeHighLight();
    }, [closeHighLight]);

    useEffect(() => {
        if (timer2) {
            clearTimeout(timer2);
        }
        timer2 = setTimeout(() => {
            if (!Array.isArray(detail?.dialogRecords?.dialogSentenceList)) {
                setDialogSentenceList([]);
                return;
            }

            let highlightMessageIndex = 1;
            let ret = detail?.dialogRecords?.dialogSentenceList.map((item, index) => {
                let ret = {
                    ...item,
                    playRudio: playRudio,
                    isPlaying: isPlaying,
                    sendCurrentTimeRange: sendCurrentTimeRange.bind(null, item),
                    // canRemarkEdit: canRemarkEdit,
                    // fieldFlag: fieldFlag,
                    dataIdForCreateRemark: props.id,
                    needHighlightWhenHit: true,
                    isHitHighlight: hitHighlightList.includes(`${index + 1}`),
                    hideChatTitle: true,
                    hideEmotion: true,
                    hidePlay: true,
                    renderAvatar: (sender) => (
                        <div style={{ color: 'rgb(44, 83, 236)', textAlign: 'center' }}>
                            <Icon
                                style={{ fontSize: '28px' }}
                                type={
                                    sender === 'agent' ? 'ic-customer-service-kefu' : 'ic-user-ren'
                                }
                            />
                            <div style={{ fontSize: 12, marginTop: -6 }}>
                                {sender === 'agent' ? '顾问' : '客户'}
                            </div>
                        </div>
                    ),
                };
                if (
                    inspectDataSource === Udesk.enums.inspectDataSources.voiceCall.id ||
                    inspectDataSource === Udesk.enums.inspectDataSources.videoCall.id
                ) {
                    ret.highlightMessageIndex = highlightMessageIndex;
                    highlightMessageIndex++;
                } else {
                    // const content = item?.content ? JSON.parse(item.content) : {};
                    // if(content.type && isHighlightHitType(content.type)){
                    ret.highlightMessageIndex = highlightMessageIndex;
                    highlightMessageIndex++;
                    // }
                }

                //格式化语音类型的数据
                if (
                    [
                        Udesk.enums.inspectDataSources.voiceCall.id,
                        Udesk.enums.inspectDataSources.wechatRadio.id,
                        Udesk.enums.inspectDataSources.videoCall.id,
                    ].includes(inspectDataSource)
                ) {
                    //构造开始截止时间
                    let created_at = getAudioItemTime(item.fromSec, item.endSec);
                    //后端返回的语音类型的数据没有id，规则测试页面造了id字段，所以判断一下
                    if (!ret.id) {
                        ret.id = `dialogSentenceList-item-${index}`;
                    }
                    //企业微信类型的数据解构和文本类型是一致的，所以这里只对语音类型的数据增加__type以作区分
                    ret.__type = 'call';
                    ret.sender = item.role;
                    ret.created_at = created_at;
                    //content: "{"type":"message","data":{"content":"企微测试lianpp"}}"
                    ret.content = {
                        // ...item,
                        type: 'message',
                        data: {
                            content: item.text,
                            fromSec: item.fromSec,
                            endSec: item.endSec,
                        },
                    };
                }
                return ret;
            });
            setDialogSentenceList(ret);
            setLoadingDelay(false);
            timer2 = null;
        }, 100);
    }, [
        detail?.dialogRecords?.dialogSentenceList,
        inspectDataSource,
        sendCurrentTimeRange,
        playRudio,
        props.id,
        isPlaying,
        /** 用于命中时高亮显示的 index 数组 */
        hitHighlightList,
    ]);

    useEffect(() => {
        // if (detailId === detail.id) return;
        let pointsHighlight: any[] = [];
        //遍历一级分类
        (detail?.pointCategoryList ?? []).forEach((pointCategory: any) => {
            //遍历二级分类
            if (Array.isArray(pointCategory.children)) {
                pointCategory.children.forEach((secondCategory: any) => {
                    if (Array.isArray(secondCategory.pointDataList)) {
                        let pointDataList = secondCategory.pointDataList
                            .filter((i) => i.ruleType === Udesk.enums.ruleTypes.common.id)
                            .map((i) => {
                                let { highlightGroupList = [], highlightSeqList, ...args } = i;
                                //兼容老的质检任务，通过highlightSeqList构建highlightGroupList
                                if (
                                    !highlightGroupList?.length &&
                                    Array.isArray(highlightSeqList) &&
                                    highlightSeqList.length
                                ) {
                                    return {
                                        ...args,
                                        highlightGroupsList: highlightSeqList.map(
                                            (seq, seqIndex) => {
                                                return {
                                                    highlightItemList: [
                                                        {
                                                            highlightType: 1,
                                                            index: seq,
                                                            length: null,
                                                            start: null,
                                                            groupIndex: seqIndex,
                                                            itemIndex: 0,
                                                        },
                                                    ],
                                                };
                                            }
                                        ),
                                    };
                                }
                                return {
                                    ...args,
                                    highlightGroupsList: (highlightGroupList || []).map(
                                        (g, groupIndex) => {
                                            return {
                                                ...g,
                                                highlightItemList: (g.highlightItemList || []).map(
                                                    (i, itemIndex) => ({
                                                        ...i,
                                                        groupIndex,
                                                        itemIndex,
                                                    })
                                                ),
                                            };
                                        }
                                    ),
                                };
                            });
                        pointsHighlight = [...pointsHighlight, ...pointDataList];

                        const pointsHighLightTotal = pointsHighlight.length;
                        let flowDataList: any[] = [];
                        secondCategory.pointDataList
                            .filter((i) => i.ruleType === Udesk.enums.ruleTypes.flow.id)
                            .forEach((i) => {
                                let { canvasNodeMatchResultList } = i;
                                if (!canvasNodeMatchResultList) return;
                                canvasNodeMatchResultList.forEach((canvasNode) => {
                                    canvasNode.parentId = 'flowNode';
                                    canvasNode.pointId = `${canvasNode.nodeId}`;

                                    let { highlightGroupList = [], ...args } = canvasNode;
                                    flowDataList.push({
                                        ...args,
                                        highlightGroupsList: (highlightGroupList || []).map(
                                            (g, groupIndex) => {
                                                return {
                                                    ...g,
                                                    highlightItemList: (
                                                        g.highlightItemList || []
                                                    ).map((i, itemIndex) => ({
                                                        ...i,
                                                        groupIndex:
                                                            pointsHighLightTotal + groupIndex,
                                                        itemIndex,
                                                    })),
                                                };
                                            }
                                        ),
                                    });
                                });
                            });
                        pointsHighlight = [...pointsHighlight, ...flowDataList];
                    }
                });
            }
        });

        setPointsHighlight(pointsHighlight);
    }, [detail?.pointCategoryList]);

    useEffect(() => {
        if (!autoStepToNext) {
            props.timeValue === 'null' && setSentenceIndex(null);
            return;
        }
        let sentenceIndex = 0;
        timeRangeList.some((range, index) => {
            sentenceIndex = index;
            return range[1] > props.timeValue;
        });
        props.timeValue !== null && props.timeValue !== 'null' && setSentenceIndex(sentenceIndex);
        props.timeValue === 'null' && setSentenceIndex(null);
    }, [props.timeValue, timeRangeList]);

    useEffect(() => {
        if (sentenceIndex === null) return;
        chatRecordRef.current?.scrollTo?.({
            index: sentenceIndex,
            align: 'top',
            offset: height / 4,
        });
    }, [sentenceIndex]);

    const { ref, width = 1, height: h = 1 } = useResizeObserver<HTMLDivElement>();

    useEffect(() => {
        const timer = setTimeout(() => {
            let newHeight = h < 1 ? 1 : h;
            if (newHeight !== height) {
                setHeight(newHeight);
            }
        }, 300);
        return () => {
            clearTimeout(timer);
        };
    }, [width, h, height]);

    useEffect(() => {
        currentHighLightPointOrSmartKey && setKeywords('');
    }, [currentHighLightPointOrSmartKey]);

    return (
        <div
            className="audio-call-content-info-v3"
            style={isTest ? { borderLeft: '1px solid rgba(0, 0, 0, 0.1)' } : undefined}
            ref={ref}
        >
            <div
                className="audio-call-content-info-record"
                style={{
                    backgroundColor:
                        inspectDataSource !== Udesk.enums.inspectDataSources.ticket.id
                            ? 'rgba(0, 0, 0, 0.03)'
                            : '#fff',
                }}
            >
                <ChatRecord
                    key={virtual ? `${height}` : 'un-virtual-list'}
                    data={dialogSentenceList}
                    height={height}
                    showTopMore={false}
                    loading={loadingDelay}
                    defaultScrollToTop={
                        inspectDataSource !== Udesk.enums.inspectDataSources.wechatDialogue.id
                    }
                    propsFromDetail={{}}
                    highlightPoint={currentHighLightPointOrSmartKey}
                    // allHighlightPoints={allHighlightPoints}
                    closeHighlight={closeHighLightAndClearKeyWords}
                    manualHighlightIndex={sentenceIndex}
                    ref={chatRecordRef}
                    virtual={virtual}
                    searchHighlightKeywords={keywords}
                    searchHighlightRoleType={type}
                    // markFlag={MarkFlag}
                    callId={detail?.callId}
                    changeToHighlightItemsCallDetail={changeToHighlightItemsCallDetail}
                    showCheckbox={showCheckbox}
                    onMessageItemCheckboxClick={onMessageItemCheckboxClick}
                    allHighlightMap={indexPointTag}
                    inspectDataSource={inspectDataSource}
                    isDebug={isDebug}
                />
            </div>
        </div>
    );
});

export default React.memo(ExportComponent);

function getAudioItemTime(startPoint, endPoint) {
    let start = Udesk.utils.date.formatDurationWithMillisecond(startPoint);
    let end = Udesk.utils.date.formatDurationWithMillisecond(endPoint);
    return `${start} - ${end}`;
}
